module.exports = __webpack_public_path__ + "static/media/ig12.c5c648b1.jpg";